import * as copy from './copy';

module.exports = {
    copy
};
